import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'input',
    'title',
    'hint',
    'preview',
    'browseLabel',
    'actions',
    'removeButton',
    'removeFlag',
    'upload'
  ]

  connect() {
    this.hasExisting = this.data.get('hasExisting') === 'true'
    this.syncUi()
  }

  browse(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  changed() {
    const file = this.inputTarget.files?.[0]
    if (!file) {
      this.syncUi()
      return
    }

    this.clearRemoveFlag()
    this.titleTarget.textContent = file.name
    this.hintTarget.textContent = 'Ready to upload'
    this.setImagePreview(file)
    this.syncUi({ selected: true })
  }

  remove(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.setRemoveFlag()
    this.hasExisting = false
    this.titleTarget.textContent = this.data.get('emptyTitle') || 'Add a photo'
    this.hintTarget.textContent = this.data.get('emptyHint') || 'JPG, PNG, GIF, or WebP'
    this.resetPreview()
    this.syncUi({ selected: false, existing: false })
  }

  syncUi({ selected = this.hasSelectedFile(), existing = this.hasExisting && !this.isMarkedForRemoval() } = {}) {
    const hasPhoto = selected || existing

    if (this.hasUploadTarget) {
      this.uploadTarget.classList.toggle('photo-upload--has-photo', hasPhoto)
    }

    if (this.hasBrowseLabelTarget) {
      this.browseLabelTarget.textContent = hasPhoto ? 'Change' : 'Browse'
    }

    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.classList.toggle('d-none', !hasPhoto)
    }

    if (this.hasActionsTarget) {
      this.actionsTarget.classList.toggle('photo-upload__actions--split', hasPhoto)
    }
  }

  hasSelectedFile() {
    return this.hasInputTarget && this.inputTarget.files?.length > 0
  }

  isMarkedForRemoval() {
    return this.hasRemoveFlagTarget && this.removeFlagTarget.value === '1'
  }

  setImagePreview(file) {
    if (!this.hasPreviewTarget) return

    const reader = new FileReader()
    reader.onloadend = () => {
      this.previewTarget.innerHTML = `<img src="${reader.result}" alt="Photo preview">`
    }
    reader.readAsDataURL(file)
  }

  resetPreview() {
    if (!this.hasPreviewTarget) return

    this.previewTarget.innerHTML = '<i class="ri-image-fill" aria-hidden="true"></i>'
  }

  setRemoveFlag() {
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = '1'
  }

  clearRemoveFlag() {
    if (this.hasRemoveFlagTarget) this.removeFlagTarget.value = '0'
  }
}
